
import { Chart, registerables, _adapters } from 'chart.js';
import { GlobalVariablesService } from '../../services/global-variables.service';
import { timeDay } from 'd3';
import { time } from '../../services/global-variables.service';
import { enUS } from 'date-fns/locale'
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';


export class ChartJsEnergyGraph {

    graph: any;
    miniGraph: any;

    private xValues;
    private yValues;
    timespan;

    loading = true;

    constructor(private data: any, private globalVars: GlobalVariablesService) {

    }


    drawGraph() {

        Chart.register(...registerables);
        Chart.register(zoomPlugin);
        if (!this.data) {
            return;
        }

        this.convertDataToChartJs();
        this.loading = true;

        this.graph = new Chart('graph1', {
            type: 'bar',
            data: {
                labels: this.xValues,
                datasets: [{
                    label: 'Energy Usage',
                    data: this.yValues,
                    backgroundColor: '#0E8E75'
                },
                ]

            }
            ,
            options: {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: 'Energy Usage'
                    },
                    tooltip: {
                        callbacks: {
                            footer: (point) => {
                                let value = point[0].parsed.y;

                                let tarrif = this.globalVars.getTarrif();

                                let cost = value * tarrif;

                                return "Cost: £" + cost.toFixed(2);
                            },
                            label: (point) => {
                                let value = point.parsed.y;
                                return " Energy " + value + " Wh";
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        ticks: {
                            callback: (value, index, values) => {
                                return value + 'Wh';
                            }
                        }

                    }
                }

            }
        }
        );

        this.loading = false;

    }

    addPowerGraph(data) {

        let dataArray = [];

        for (let i in data) {
            dataArray.push(
                {
                    x: data[i].timestamp,
                    y: data[i].value
                }
            )
        }

        this.miniGraph = new Chart('miniGraph', {
            type: 'line',
            data: {
                datasets: [{
                    label: "Power Usage",
                    data: dataArray,
                    borderWidth: 1,
                  pointRadius: 0,
                    borderColor: '#0E8E75',
                    backgroundColor: '#0E8E75',
                    stepped: 'after'
                
                }]
            },
            options: {
                scales: {
                    x: {
                        type: 'time',
                        adapters: {
                            date: {
                                locale: enUS
                            },

                        },
                        time: {
                            unit: 'day',
                        }
                    },
                    y: {
                        ticks: {
                            callback: (value, index, values) => {
                                return value + 'W';
                            }
                        }
                    }
                },
                maintainAspectRatio: false,
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (point) => {
                                let value = point.parsed.y;
                                return " Power Usage " + value + "W";
                            }
                        }
                    },
                    legend: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: 'Power Usage'
                    },
                    zoom: {
                        limits: {

                        },
                        zoom: {
                            drag: {
                                enabled: true

                            },
                            mode: 'x',

                        }
                    }

                }


            },

        });
    }

    convertDataToChartJs() {

        this.xValues = [];
        this.yValues = [];

        for (let i in this.data) {
            let dataPoint = this.data[i];
            let timespan = new Date(dataPoint.timestamp).toDateString();
            let value = dataPoint.value / 1000;
            this.xValues.push(timespan);
            this.yValues.push(value);
        }

    }


}
